export const getRandomItem = <T>(arr: T[]): T => {
  return arr[Math.floor(Math.random() * arr.length)];
};

export const getArrayNumberRange = (start: number, stop: number) =>
  Array.from({ length: stop - start }, (value, index) => start + index);
